export const LIB_VERSION = '18.5.1'; // autogenerated
//# sourceMappingURL=version.js.map